/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы регистрации
   */
  app.CommonAuthFormView = app.FormView.extend({
    submitButton: '.button_blue',

    run: function () {
      this.$submitButton = this.$(this.submitButton);
      app.FormView.prototype.run.apply(this);
    },

    /**
     * Возвращает данные формы для отправки по апи
     */
    getData: function () {
      var attributes = {};

      this.$fields.each(function () {
        if ($(this).is(':checkbox')) {
          if ($(this).prop('checked')) {
            attributes[$(this).data('name')] = 1;
            $(this).val('1');
          } else {
            attributes[$(this).data('name')] = 0;
            $(this).val('0');
          }
        } else {
          attributes[$(this).data('name')] = $(this).val();
        }
      });
      if (this.settlementModel && this.settlementModel.get('id')){
        attributes.settlement_id = this.settlementModel.get('id');
      }
      return attributes;
    },

    /**
     * Отправка формы на подтверждение авторизации
     */
    submit: function (e) {
      var data = this.getData();

      e.preventDefault();

      /**
       * Проверяем, совпадают ли данные текущего запроса с данными предыдущего
       * если совпадают, не отправляем запрос
       */
      if (this.lastData && _.isEqual(this.lastData, data)) {
        return;
      }
      this.lastData = data;

      this.model.save(data, {
        'success': this.success.bind(this),
        'error': this.error.bind(this)
      });
    },

    /**
     * Успешная валидация формы
     */
    success: function (successEvent) {
      app.FormView.prototype.success.apply(this, arguments);
      app.helpers.StorageHelper.LS.set('lastLoginData', this.lastData.type);
      this.$el.submit();
      window.location.assign('/');
    },

    /**
     * Обработчик ошибки сохранения формы
     */
    error: function (model, response) {
      /**
       *  Удаляем данные прошлого запроса, чтобы блокировать повторяющиеся запросы только при успешном логине
       */
      this.lastData = null;
      app.FormView.prototype.error.apply(this, arguments);
    },

    /**
     * Заполнение ошибок
     * @param {arr} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      var that = this;
      var $errorSpan;

      errors.forEach(function (error) {
        $errorSpan = $('#' + that.formName + '-' + error.field + '-error');
        $errorSpan.text(error.message);
        $errorSpan.show();
        $('#' + that.formName + '-' + error.field).parent().addClass('invalid');
      });
    },

    /**
     * Очистка ошибок
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).parent().removeClass('invalid');
      });
      this.$el.find('.invalid_message').text('').hide();
    }
  });
})(jQuery);

}.call(window));